import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { AuthGuardService } from './services/common/auth-guard.service';
import { AuthenticationService } from './services/common/authentication.service';
import { ClickOutsideModule } from 'ng-click-outside';
import { ListingComponent } from './components/common/listing/listing.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { HeaderStaffComponent } from './components/common/header-staff/header-staff.component';
import { ChecklistComponent } from './components/common/checklist/checklist.component';
import { LoaderComponent } from './components/common/loader/loader.component';
import { SidebarComponent } from './components/common/sidebar/sidebar.component';
import { StudentServiceService } from './services/common/student-service.service';
import { CommonService } from './services/common/common.service';
import { HttpClientModule, } from '@angular/common/http';
import { PersistentStorageService } from './services/common/persistent-storage.service';
import { StudentHomeComponent } from './components/student-home/student-home.component';
import { LoaderService } from './services/common/loader.service';
import { FormsModule } from '@angular/forms';
import { HeaderService } from './services/common/header.service';
import { GoBackComponent } from './components/common/go-back/go-back.component';
import { HeaderStudentComponent } from './components/common/header-student/header-student.component';
import { CloudServiceService } from './services/cloud/cloud-service.service';
import { HomeViewOnlyComponent } from './components/home-viewonly/home-viewonly.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderStaffComponent,
    ListingComponent,
    StudentHomeComponent,
    ChecklistComponent,
    HeaderStudentComponent,
    LoaderComponent,
    SidebarComponent,
    GoBackComponent,
    HomeViewOnlyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase), // imports firebase/app needed for everything
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    ClickOutsideModule, //ClickOutside
    NgCircleProgressModule.forRoot({
      "radius": 30,
      "space": -5,
      "outerStrokeGradient": true,
      "outerStrokeWidth": 5,
      "outerStrokeColor": "#00657c",
      "outerStrokeGradientStopColor": "#53a9ff",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 5,
      "animateTitle": false,
      "animationDuration": 1000,
      "showUnits": false,
      "showBackground": false,
      "clockwise": true,
      "startFromZero": false,
      "showTitle": false,
      "showSubtitle": false
    })
  ],
  providers: [
    AuthGuardService,
    AuthenticationService,
    StudentServiceService,
    CommonService,
    PersistentStorageService,
    LoaderService,
    HeaderService,
    CloudServiceService
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: LoaderInterceptor,
    //   multi: true,
    // }
  ],
  bootstrap: [AppComponent],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
